import styled from "styled-components";

export const HealthAndSafetyContainer = styled.div`
  width: 100%;
  padding: 2rem 1.25rem 2.4rem;
  background: linear-gradient(180deg, #eef4f4 0%, #e4f0e0 100%);
  border-top: 2px solid ${({ theme }) => theme.colors.primary};
`;

export const HealthAndSafetyWrapper = styled.div`
  width: min(1100px, 100%);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const HealthAndSafetyKicker = styled.p`
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkBackground};
  opacity: 0.72;
`;

export const HealthAndSafetyTitle = styled.h1`
  margin: 0.5rem 0 0;
  font-size: clamp(1.6rem, 3.5vw, 2.4rem);
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const HealthAndSafetyText = styled.p`
  width: min(780px, 100%);
  margin: 0.9rem 0 0;
  line-height: 1.85;
  color: ${({ theme }) => theme.colors.text};
`;

export const CredentialWrapper = styled.div`
  width: min(980px, 100%);
  margin: 1.3rem auto 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const AccreditationCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 1rem;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(10, 10, 10, 0.08);
`;

export const HealthAndSafetyCreditations = styled.img`
  width: auto;
  max-width: 100%;
  height: 80px;

  @media (max-width: 767px) {
    height: 70px;
  }
`;

export const HealthAndSafetyPageLink = styled.a`
  display: inline-block;
  margin-top: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkBackground};
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
